import { render } from "./PflegeView.vue?vue&type=template&id=36d4e23d"
import script from "./PflegeView.vue?vue&type=script&lang=js"
export * from "./PflegeView.vue?vue&type=script&lang=js"

import "./PflegeView.vue?vue&type=style&index=0&id=36d4e23d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__